import { defaultOptions } from 'lib/hooks/AuditLogFilters/useAuditLogFilter';
import { switchAccountSuccess } from 'store/account/actions';
import { Action, Nullable } from 'modules/types/common';
import * as actions from './actions';
import { AuditPageState, AuditLogOptions } from './types';

export interface AuditState {
  isFetching: boolean;
  error: Nullable<Error>;
  pages: AuditPageState | {};
  totalRowCount: Nullable<number>;
  totalPages: Nullable<number>;
  currentPageNumber: Nullable<number>;
  filterOptions: AuditLogOptions;
}

const initialState: AuditState = {
  isFetching: false,
  error: null,
  pages: {},
  totalRowCount: null,
  totalPages: null,
  currentPageNumber: 1,
  filterOptions: defaultOptions
};

const auditReducer = (state = initialState, action: Action) => {
  const { data } = action.payload || {};

  switch (action.type) {
    case switchAccountSuccess.type:
      return initialState;
    case actions.GET_AUDITS:
      return {
        ...state,
        error: null,
        isFetching: true
      };
    case actions.GET_AUDITS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        totalRowCount: data.totalRowCount,
        totalPages: data.totalPages,
        pages: {
          [data.pageNumber]: data.activityLogs
        },
        currentPageNumber: 1
      };
    case actions.GET_AUDITS_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case actions.SET_AUDITS_CURRENT_PAGE:
      return {
        ...state,
        currentPageNumber: action.payload.pageNumber
      };
    case actions.RESET:
      return {
        ...state,
        filterOptions: []
      };

    case actions.SET_FILTER_OPTIONS:
      return {
        ...state,
        filterOptions: action.payload
      };
    case actions.DOWNLOAD_AUDIT_LOG_FILTERS:
      return {
        ...state,
        auditLogFiltersDownloadStatus: 'pending',
        error: null
      };

    case actions.DOWNLOAD_AUDIT_LOG_FILTERS_FAIL:
      return {
        ...state,
        auditLogFiltersDownloadStatus: 'fail',
        error: action.error
      };
    case actions.DOWNLOAD_AUDIT_LOG_FILTERS_SUCCESS:
      return {
        ...state,
        auditLogFiltersDownloadStatus: 'success'
      };
    default:
      return state;
  }
};

export default auditReducer;
